import { render, staticRenderFns } from "./TaskSessionsAppliedVolunteers.vue?vue&type=template&id=50b49415&"
import script from "./TaskSessionsAppliedVolunteers.vue?vue&type=script&lang=js&"
export * from "./TaskSessionsAppliedVolunteers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports